import React from "react";

function QuickContact() {
  return (
    <div className="row info">
      <div className="col-lg-4 col-md-3 item text-center border-right xs-no-border-right xs-border-bottom border-color-medium-gray xs-margin-20px-bottom xs-padding-20px-bottom">
        <span className="icon font-size32">
          <i className="icon-phone" />
        </span>
        <div className="cont">
          <h6>Phone</h6>
          <p>(+91) 8152922786</p>
        </div>
      </div>
      <div className="col-lg-4 col-md-5 item text-center border-right xs-no-border-right xs-border-bottom border-color-medium-gray xs-margin-20px-bottom xs-padding-20px-bottom">
        <span className="icon font-size32">
          <i className="icon-map" />
        </span>
        <div className="cont">
          <h6>Address</h6>
          <p>#17/2 Annayareddy layout, Kundanahalli colony, Bangalore</p>
        </div>
      </div>
      <div className="col-lg-4 col-md-4 item text-center">
        <span className="icon font-size32">
          <i className="icon-envelope" />
        </span>
        <div className="cont">
          <h6>Email</h6>
          <p>irfangg66@gmail.com</p>
        </div>
      </div>
    </div>
  );
}
export default QuickContact;
